import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useExportDataset } from "@/hooks/importToolXSLX";
import { ButtonsPropTypes } from "@/propTypes/Button.type";

const ExportDatasetButton = ({
  templateId,
  params,
  label = null,
  buttonProps = {},
}) => {
  const { t } = useTranslation();
  const { loading, handleExportDataset } = useExportDataset(templateId);

  return (
    <Button
      key="export"
      onClick={() => handleExportDataset("datasets", params)}
      loading={loading}
      icon={<DownloadOutlined />}
      disabled={!templateId}
      {...buttonProps}
    >
      {label ?? t("global:export")}
    </Button>
  );
};

ExportDatasetButton.propTypes = {
  templateId: PropTypes.number,
  params: PropTypes.object,
  label: PropTypes.string,
  buttonProps: ButtonsPropTypes,
};

export default ExportDatasetButton;
